import { render, staticRenderFns } from "./LiveDashboardChart.vue?vue&type=template&id=3134165f"
import script from "./LiveDashboardChart.vue?vue&type=script&lang=js"
export * from "./LiveDashboardChart.vue?vue&type=script&lang=js"
import style0 from "./LiveDashboardChart.vue?vue&type=style&index=0&id=3134165f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QResizeObserver from 'quasar/src/components/resize-observer/QResizeObserver.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QInnerLoading,QSpinner,QResizeObserver});
